import { render, staticRenderFns } from "./IRBaseButton.vue?vue&type=template&id=0d1a8160"
import script from "./IRBaseButton.vue?vue&type=script&lang=js"
export * from "./IRBaseButton.vue?vue&type=script&lang=js"
import style0 from "./IRBaseButton.vue?vue&type=style&index=0&id=0d1a8160&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports